import { render, staticRenderFns } from "./ModalFormulario.vue?vue&type=template&id=54da5f78&scoped=true"
import script from "./ModalFormulario.vue?vue&type=script&lang=js"
export * from "./ModalFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da5f78",
  null
  
)

export default component.exports